{
    angular.module('interfaceModule')
        .controller('ContactUsController',ContactUsController);
    ContactUsController.$inject = ['$scope',"utils.currentUser",'utils.constant','$state'];
    function ContactUsController($scope,currentUser,constant,$state) {
        let vm=this;
        let collect={
            'activate':activate,

        };
        vm.collect=collect;
        activate();

        function activate(){

        }
    }

}